import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { toast } from 'sonner';
import { sessionStore } from '@/lib/auth/session-store';
import { resetBranding } from '@/lib/branding';
import { authApi } from './api';

export interface SignOutOptions {
  /** call POST /auth/logout first (default true; skip when the server already revoked the session) */
  callApi?: boolean;
  /** shown as an informational toast instead of the default "signed out" success */
  reason?: string;
}

export function useLogout(): (options?: SignOutOptions) => Promise<void> {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  return useCallback(
    async ({ callApi = true, reason }: SignOutOptions = {}) => {
      if (callApi) {
        try {
          await authApi.logout();
        } catch {
          /* the session is cleared locally regardless */
        }
      }
      sessionStore.clear();
      queryClient.clear();
      resetBranding();
      if (reason) toast.info(reason);
      else toast.success('You’ve been signed out');
      await navigate({ to: '/login' });
    },
    [navigate, queryClient],
  );
}
